import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import LeadOutlook from "../components/LeadOutlook";
import { Button } from "../components/ui/button";
import { Calculator } from "lucide-react";
import ReteCostEditor from "../components/ReteCostEditor";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PublicConsulenza() {
  const { token } = useParams();
  const [rete, setRete] = useState(null);
  const [ver, setVer] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.title = "La tua analisi energetica · Torrisolare";
    axios.get(`${API}/api/public/consulenza/${token}`)
      .then((r) => setRete(r.data?.rete || null))
      .catch(() => setRete(null));
  }, [token]);

  const partner = rete && rete.brand_mode === "partner";
  const inst = rete?.installer;

  return (
    <div className="min-h-screen bg-background">
      <div className="sticky top-0 z-30 border-b border-border bg-background/90 backdrop-blur px-4 sm:px-6 py-3" data-testid="consulenza-header">
        <div className="mx-auto max-w-4xl flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          {rete && inst?.ragione_sociale ? (
            partner ? (
              <>
                <div className="flex items-center gap-2.5" data-testid="consulenza-partner-brand">
                  {inst?.logo_url ? (
                    <img src={inst.logo_url} alt={inst.ragione_sociale} className="h-[52px] w-[52px] rounded-lg object-contain bg-white border border-border" onError={(e) => { e.currentTarget.style.display = "none"; }} />
                  ) : (
                    <div className="h-[52px] w-[52px] rounded-lg bg-primary/10 text-primary flex items-center justify-center font-heading font-extrabold">{(inst?.ragione_sociale || "?").charAt(0).toUpperCase()}</div>
                  )}
                  <div className="leading-tight min-w-0">
                    <div className="font-heading font-extrabold text-sm break-words">{inst?.ragione_sociale}</div>
                    {inst?.indirizzo && <div className="text-[10px] text-muted-foreground">{inst.indirizzo}</div>}
                    {[inst?.citta, inst?.provincia].filter(Boolean).length > 0 && (
                      <div className="text-[10px] text-muted-foreground">{[inst?.citta, inst?.provincia].filter(Boolean).join(" · ")}</div>
                    )}
                    {inst?.p_iva && <div className="text-[10px] text-muted-foreground">P.IVA {inst.p_iva}</div>}
                    {inst?.telefono && <div className="text-[10px] text-muted-foreground">Tel. {inst.telefono}</div>}
                    {inst?.email && <div className="text-[10px] text-muted-foreground break-all">{inst.email}</div>}
                    {rete.partner_note && <span className="inline-block mt-1 text-[9px] font-semibold uppercase tracking-wide text-primary bg-primary/10 rounded-full px-2 py-0.5" data-testid="consulenza-partner-note">{rete.partner_note}</span>}
                  </div>
                </div>
                <div className="flex flex-col items-start sm:items-end gap-0.5 shrink-0">
                  <div className="flex items-center gap-2">
                    <img src="/torri-icon.png" alt="TORRI.SOLAR" className="h-[41px] w-[41px] rounded-full object-contain" />
                    <div className="leading-none text-left sm:text-right">
                      <div className="font-heading font-extrabold text-[20px] tracking-wide">TORRI<span style={{ color: "#FDD003" }}>.SOLAR</span></div>
                      <div className="text-[11px] tracking-[0.18em] uppercase text-muted-foreground mt-0.5">Div. Chiavi in mano</div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center gap-2">
                  <img src="/torri-icon.png" alt="TORRI.SOLAR" className="h-[41px] w-[41px] rounded-full object-contain" />
                  <div className="leading-none">
                    <div className="font-heading font-extrabold text-[20px] tracking-wide">TORRI<span style={{ color: "#FDD003" }}>.SOLAR</span></div>
                    <div className="text-[11px] tracking-[0.18em] uppercase text-muted-foreground mt-0.5">Div. Chiavi in mano</div>
                  </div>
                </div>
                <div className="flex flex-col items-start sm:items-end gap-1 shrink-0 min-w-0">
                  <span className="text-[10px] text-muted-foreground text-left sm:text-right" data-testid="consulenza-featuring">In collaborazione con l'installatore</span>
                  <div className="leading-tight text-left sm:text-right min-w-0" data-testid="consulenza-installer-anagrafica">
                    <div className="font-heading font-extrabold text-sm break-words">{inst?.ragione_sociale}</div>
                    {inst?.indirizzo && <div className="text-[10px] text-muted-foreground">{inst.indirizzo}</div>}
                    {[inst?.citta, inst?.provincia].filter(Boolean).length > 0 && (
                      <div className="text-[10px] text-muted-foreground">{[inst?.citta, inst?.provincia].filter(Boolean).join(" · ")}</div>
                    )}
                    {inst?.p_iva && <div className="text-[10px] text-muted-foreground">P.IVA {inst.p_iva}</div>}
                    {inst?.telefono && <div className="text-[10px] text-muted-foreground">Tel. {inst.telefono}</div>}
                    {inst?.email && <div className="text-[10px] text-muted-foreground break-all">{inst.email}</div>}
                  </div>
                </div>
              </>
            )
          ) : (
            <div className="flex items-center gap-2">
              <img src="/torri-icon.png" alt="TORRI.SOLAR" className="h-9 w-9 rounded-full object-contain" />
              <div className="leading-tight">
                <div className="font-heading font-extrabold text-sm tracking-wide">TORRI<span style={{ color: "#FDD003" }}>.SOLAR</span></div>
                <div className="text-[10px] text-muted-foreground uppercase tracking-[0.15em]">Div. Chiavi in mano</div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="mx-auto max-w-4xl px-4 sm:px-6 pt-10 sm:pt-12 pb-6 sm:pb-8">
        <LeadOutlook key={ver} publicToken={token} consulenzaMode />
        {rete && rete.unlocked && localStorage.getItem("rete_session") && <p className="no-print mt-4 text-sm text-muted-foreground text-center" data-testid="rete-unlocked-note">Pratica presa in carico da Torri.Solar: la proposta è gestita internamente.</p>}
        {rete && !rete.unlocked && rete.editor && localStorage.getItem("rete_session") && (
          <div className="no-print" data-testid="rete-quote-section">
            {(open || rete.compiled)
              ? <ReteCostEditor token={token} leadId={rete.lead_id} onChanged={() => setVer((v) => v + 1)} />
              : (
                <div className="mx-auto max-w-4xl px-4 sm:px-6 py-8 flex justify-center">
                  <Button size="lg" onClick={() => setOpen(true)} data-testid="rete-generate-cost-sheet-btn">
                    <Calculator className="h-4 w-4 mr-2" /> Genera scheda di costo
                  </Button>
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
}
